export default __webpack_public_path__ + "static/media/TEkaHelp.11d3dea0.svg";